/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-1",
    "aws_cloud_logic_custom": [
        {
            "name": "whitespot2",
            "endpoint": "https://gllq6fbwa3.execute-api.eu-west-1.amazonaws.com/prod",
            "region": "eu-west-1"
        }
    ],
    "aws_cognito_identity_pool_id": "eu-west-1:c6194817-ea2a-4a0b-b00c-447d33f473a7",
    "aws_cognito_region": "eu-west-1",
    "aws_user_pools_id": "eu-west-1_lHvnXG7Y6",
    "aws_user_pools_web_client_id": "2iddh9v7p4k2b5a5gaes650ica",
    "oauth": {
        "domain": "saleswhitespot27d2aa7eb-7d2aa7eb-prod.auth.eu-west-1.amazoncognito.com",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "http://localhost:3000/,https://www.whitespot.spatineo-devops.com/",
        "redirectSignOut": "http://localhost:3000/,https://www.whitespot.spatineo-devops.com/",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS",
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [
        "GOOGLE"
    ],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "white-spot-demo",
    "aws_user_files_s3_bucket_region": "eu-west-1"
};


export default awsmobile;
